// nroute premium landing — copy + data (verified facts only)
// Claims policy: only figures sourced from product docs are allowed here.
// 18,000+ programs, 50+ countries. NO acceptance rates / student counts / multipliers.

// Destination for "Request access" leads. CONFIRM before deploy (placeholder default).
export const REQUEST_ACCESS_EMAIL = 'hello@nroute.ai';

// Verified stat band — do not add unsourced numbers.
export const VERIFIED_STATS = [
  { value: '18,000+', label: 'Programs' },
  { value: '50+', label: 'Countries' },
  { value: 'AI', label: 'Guided matching' },
];

export const FEATURES = [
  {
    icon: 'MessageSquare',
    title: 'Your AI counsellor',
    body: 'Ask in plain language. nroute understands your goals and surfaces real programs — no forms to fight, no guesswork.',
  },
  {
    icon: 'Target',
    title: 'Precision matching',
    body: 'Filter by country, field, budget and intake. Every result is a program you could actually apply to.',
  },
  {
    icon: 'Library',
    title: 'A verified catalogue',
    body: 'A structured, searchable catalogue of 18,000+ programs across 50+ countries — kept current, not crowdsourced.',
  },
  {
    icon: 'Route',
    title: 'A clear route in',
    body: 'Shortlist, compare and plan your application in one place. From first question to acceptance, with direction.',
  },
];

// Contact inbox for the footer (kept as the /tmp Labs address from the prior footer).
// CONFIRM before public release.
export const CONTACT_EMAIL = 'hello@tmplabs.ai';

// Footer columns. type: 'route' (navigate) | 'top' (scroll to top) | 'external' (new tab/mailto).
// NOTE: About Us / Careers use a mailto INTERIM — no /about or /careers page exists yet.
export const FOOTER_COLUMNS = [
  {
    title: 'Platform',
    links: [
      { label: 'For Students', type: 'top' },
      { label: 'For Consultants', type: 'route', href: '/login' }, // partners use unified /login
      { label: 'Universities', type: 'route', href: '/universities' },
      { label: 'Browse Programs', type: 'route', href: '/programs' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'AI Services', type: 'route', href: '/ai/services' },
      { label: 'Essay Review', type: 'route', href: '/ai/essay-review' },
      { label: 'Recommendations', type: 'route', href: '/recommendations' },
      { label: 'Application Guide', type: 'route', href: '/user-flow' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About Us', type: 'external', href: `mailto:${CONTACT_EMAIL}?subject=Tell%20me%20about%20nroute` }, // INTERIM
      { label: 'Contact', type: 'external', href: `mailto:${CONTACT_EMAIL}` },
      { label: 'Careers', type: 'external', href: `mailto:${CONTACT_EMAIL}?subject=Careers%20at%20nroute` }, // INTERIM
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Terms of Service', type: 'route', href: '/terms' },
      { label: 'Privacy Policy', type: 'route', href: '/privacy' },
    ],
  },
];

// Compliance badges — carried over from the prior footer.
// ⚠️ These are legal claims; confirm certifications are current before public release.
export const FOOTER_BADGES = [
  { icon: 'Lock', label: 'SOC 2 Compliant' },
  { icon: 'Shield', label: 'GDPR Compliant' },
];

export const FOOTER_LOCATIONS = ['Singapore'];

export const STEPS = [
  {
    number: '01',
    title: 'Tell nroute your goal',
    body: 'Country, field, budget, timeline — whatever you know. Start a conversation, not a questionnaire.',
  },
  {
    number: '02',
    title: 'Explore AI-matched programs',
    body: 'See programs matched to you from a verified catalogue of 18,000+ across 50+ countries.',
  },
  {
    number: '03',
    title: 'Chart your route',
    body: 'Shortlist, compare and plan. Your north star stays fixed while the path comes into focus.',
  },
];
